import React from 'react'
import { connect } from 'react-redux'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import uniAdm01 from '../../images/hero_img_admissions.png'
import uniAdm02 from '../../images/img_admission_01.png'
import uniAdm03 from '../../images/img_admission_02.png'
import uniAdm04 from '../../images/img_admission_03.png'
import { usersGetDetailAsync } from '../../actions/users.js'
import { Link } from 'react-router-dom'
import { accesslog, translate } from '../../helpers/global.js'

class UniAdmission extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {
    const { globalGetLanguages } = this.props;

    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="section-top-solution relative bg-gray" style={{
          position: 'relative',
          paddingTop: '120px',
        }}>
          <div className="gray-curve-bottom-right"></div>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <div className="sec-desc">
                  <h1 className='m-t-0 m-b-24'>
                    Smarter Student
                    <br/>
                    Selection with ASTRNT
                  </h1>
                  <p className='text-normal-2'>
                    ASTRNT helps universities and education partners evaluate applicants in a structured, consistent, and flexible way. From video interviews to written and scenario-based assessments, everything runs on one platform designed for clarity and scale.
                  </p>
                  <br />
                  <div className={`ban-link`} style={globalGetLanguages == 'id' ? {margin: '0'} : {margin: '8px 0 0'}}>
                    <a onClick={() => {
                      document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                      accesslog('admissions', 'button_talk_to_an_expert');
                    }} className="request-demo-logged">{translate(globalGetLanguages,'HOMEPAGE_BUTTON_REQUEST_DEMO')}</a>
                  </div>
                </div>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={uniAdm01} />
              </div>
            </div>
          </section>
        </div>
        <div className="curved-shape"></div>
        <div className="section-white" style={{overflow: 'hidden', position: 'relative'}}>
          <section className='flex-container' style={{zIndex: '2', position: 'relative'}}>
            <div className='flex-item-right flex-container flex-end align-items-center flex-padding-1'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={uniAdm02} />
              </div>
            </div>
            <div className='flex-item-left p-l-30'>
              <div className='vertical-item--center'>
                <div className="sec-desc">
                  <h2 style={{fontWeight:'700'}}>
                    Designed for Fair and Scalable 
                    Student Evaluation
                  </h2>
                  <p className='p-r-20'>
                    Selecting students is not just about academic records. ASTRNT helps institutions understand each applicant’s motivation, thinking process, communication abilities, and readiness for the program.
                  </p>
                  <ul className="m-b-32 m-t-30">
                    <li><i className="fas fa-check" />Structured video interviews</li>
                    <li><i className="fas fa-check" />Behavioral and situational judgment assessments</li>
                    <li><i className="fas fa-check" />Language proficiency checks</li>
                    <li><i className="fas fa-check" />Custom flows for each program or degree level</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden', position:'relative'}}>
          <section className='flex-container' style={{zIndex: '2', position:'relative'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <div className="sec-desc">
                  <h2 style={{fontWeight:'700'}}>
                    Make Every Decision Consistent
                    and Defensible
                  </h2>
                  <p className='p-r-40'>
                    All applicants go through the same process. That means better fairness, stronger integrity, and clearer insights to compare and select.
                  </p>
                  <ul className="m-b-32 m-t-30">
                    <li><i className="fas fa-check" />Standardised scoring rubrics</li>
                    <li><i className="fas fa-check" />AI-assisted evaluation</li>
                    <li><i className="fas fa-check" />Alerts for suspicious activities</li>
                    <li><i className="fas fa-check" />Side-by-side candidate comparison</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center p-l-40'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={uniAdm03} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden', position: 'relative'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-right flex-container flex-end align-items-center flex-padding-1'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={uniAdm04} />
              </div>
            </div>
            <div className='flex-item-left p-l-70'>
              <div className='vertical-item--center'>
                <div className="sec-desc">
                  <h2 style={{fontWeight:'700'}}>
                    Flexible for Any Admissions Model
                  </h2>
                  <p>
                    ASTRNT adapts to your calendar, structure, and student type. Whether for undergraduate, postgraduate, scholarship, or exchange programs, you can fully customize the experience.
                  </p>
                  <ul className="m-b-32 m-t-30">
                    <li><i className="fas fa-check" />Choose the right question types and timing</li>
                    <li><i className="fas fa-check" />Support for remote and international applicants</li>
                    <li><i className="fas fa-check" />No installation needed, mobile-friendly</li>
                    <li><i className="fas fa-check" />Branding and introduction content tailored to your institution</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          {/* <div className="red-curve-bottom-left"></div> */}
        </div>
        <div className="section-red red-triangle-left section-slider center" style={{
          position: 'relative', 
          overflow: 'hidden',
          height: '500px',
        }}>
          <div style={{
              color: '#fff',
              justifyItems: 'center',
              marginTop: '50px',
            }}>
              <h1 className='title-1'>
                Try Our Assessment Materials
              </h1>
              <div style={{
                width: '30%',
                textAlign: 'left',
              }}>
                <p className="text-normal-1">
                  Use our ready-made content or bring your own. ASTRNT supports:
                </p>
                <ul className='list-1'>
                  <li>
                    <div>
                      <i className="fas fa-check check-red-white" />
                      <p className='text-normal-1'>
                        Psychometric tests
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-red-white" />
                      <p className='text-normal-1'>
                        Language and communication tests
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-red-white" />
                      <p className='text-normal-1'>
                        Situational and behavioral judgment
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-red-white" />
                      <p className='text-normal-1'>
                        Case-based assessments
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-red-white" />
                      <p className='text-normal-1'>
                        Interview preparation for students
                      </p>
                    </div>
                  </li>
                </ul>
                <a className='btn btn-secondary-red' href='/assessments-and-interviews'
                  onClick={() => accesslog('admissions', 'button_explore_assessment_interview')}
                >
                  Explore Our Assessments & Interviews
                </a>
              </div>
            </div>
          <span class="white-curve-bottom-right"></span>
        </div>
        <div className="section-white center"
          style={{
            textAlign: '-webkit-center',
            minHeight: '366px',
            padding: '56px 0',
            position: 'relative',
          }}
        >
          <div className='gray-triangle-bottom-right' style={{background:'#F7F7F7'}}>
            <div className='gray-small-triangle-bottom-right' style={{background:'#EDEDED'}}></div>
          </div>
          <div>
            <h1 className='title-1'>
              Trusted by Leading Universities
              <br />
              and Programs
            </h1>
            <p style={{
              margin: '20px 0',
            }}>
              Globally top-ranked institutions with applicants from all over the world use ASTRNT to streamline
              <br />
              their selection process while improving objectivity and speed. Let us help you do the same.
            </p>
            <div>
              <a className='btn btn-primary-red' onClick={() => {
                document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                accesslog('admissions', 'button_talk_to_an_expert');
              }}>
                Talk to an Expert
              </a>
            </div>
          </div>
        </div>
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UniAdmission)
